/* A Leading Role — Pair It With / bundle & save (loaded after alr.js from layout/theme.liquid).
   Pairings live on product TAGS (editable in Shopify admin, no code change needed):
     pair:<family>      signature | barbie | mermaid | miraculous | cooking | accessory
     pairwith:<handle>  curated partner shown on the product page + in the cart nudge (may repeat)
     addon:<handle>     optional accessory (20% off with any dress up)
   The money is done by Shopify AUTOMATIC DISCOUNTS (any 2 in a family = 10%, Signature
   Cooking tiers 10/15/20%, "Add-On Accessory" 20%) — this file only surfaces them and
   makes them one tap. It deliberately does not touch alr.js: cart adds are routed through
   alr.js's own delegated handlers (a synthetic click on a [data-crec-vid] button, and the
   [data-modal="bag"] drawer opener), so the badge/toast/drawer behave exactly as they do
   for every other add on the site. Product data comes from the public
   /products/<handle>.js endpoint (tags included), cached per handle for the page. */
(function(){
'use strict';
var DRESS = {signature:1, barbie:1, mermaid:1, miraculous:1};
var CACHE = {};
function esc(s){ return String(s == null ? '' : s).replace(/[&<>"]/g, function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]; }); }
function money(cents){ return '$' + (cents/100).toFixed(2); }
function toast(msg){
  var t = document.getElementById('toast'); if(!t) return;
  t.innerHTML = msg; t.classList.add('show');
  clearTimeout(t._h); t._h = setTimeout(function(){ t.classList.remove('show'); }, 2200);
}
function getProduct(handle){
  if(!handle) return Promise.resolve(null);
  if(!CACHE[handle]){
    CACHE[handle] = fetch('/products/' + encodeURIComponent(handle) + '.js')
      .then(function(r){ return r.ok ? r.json() : null; }).catch(function(){ return null; });
  }
  return CACHE[handle];
}
function tagsOf(p){
  var o = {family:'', partners:[], addon:''};
  ((p && p.tags) || []).forEach(function(t){
    if(t.indexOf('pair:') === 0) o.family = t.slice(5);
    else if(t.indexOf('pairwith:') === 0) o.partners.push(t.slice(9));
    else if(t.indexOf('addon:') === 0) o.addon = t.slice(6);
  });
  return o;
}
/* hand a variant id to alr.js's own quick-add path (badge + toast + drawer for free) */
function addViaTheme(variantId){
  var b = document.createElement('button');
  b.type = 'button'; b.setAttribute('data-crec-vid', String(variantId)); b.hidden = true;
  document.body.appendChild(b);
  b.dispatchEvent(new MouseEvent('click', {bubbles:true, cancelable:true, view:window}));
  setTimeout(function(){ if(b.parentNode) b.parentNode.removeChild(b); }, 0);
}
/* ---------- product page: size sync + Add Both ---------- */
function syncSizes(){
  var on = document.querySelector('.pd-opt button.on'); if(!on) return;
  var val = on.getAttribute('data-optval');
  document.querySelectorAll('select.pw-size').forEach(function(sel){
    for(var i = 0; i < sel.options.length; i++){ if(sel.options[i].text === val){ sel.selectedIndex = i; break; } }
  });
}
function addBoth(btn){
  var mainEl = document.getElementById('pd-variant-id');
  var partnerEl = document.getElementById(btn.getAttribute('data-pair-select'));
  var mainId = mainEl ? parseInt(mainEl.value, 10) : null;
  var partnerId = partnerEl ? parseInt(partnerEl.value, 10) : null;
  var mainBtn = document.getElementById('pd-add');
  if(!mainId || (mainBtn && mainBtn.disabled)){ toast('Pick a size first'); return; }
  if(!partnerId){ toast('Pick a size for the second piece'); return; }
  var label = btn.textContent;
  btn.disabled = true; btn.textContent = 'Adding…';
  fetch('/cart/add.js', {
    method:'POST', headers:{'Content-Type':'application/json'},
    body: JSON.stringify({items:[{id: mainId, quantity: 1}]})
  }).then(function(r){
    if(!r.ok) throw new Error('add failed');
    addViaTheme(partnerId);              /* second piece goes through alr.js: badge, toast, drawer */
  }).catch(function(){
    toast('Could not add both &mdash; please try one at a time');
  }).then(function(){ btn.disabled = false; btn.textContent = label; });
}
/* ---------- cart drawer: nudge card + savings line ---------- */
var seq = 0;
function nudgeHtml(head, p){
  var variants = (p.variants || []).filter(function(v){ return v.available; });
  if(!variants.length) return '';
  var img = p.featured_image || (p.images && p.images[0]) || '';
  var sizeSel = variants.length > 1
    ? '<select class="cp-size" aria-label="Size">' + variants.map(function(v){ return '<option value="' + v.id + '">' + esc(v.title) + '</option>'; }).join('') + '</select>'
    : '<input type="hidden" class="cp-size" value="' + variants[0].id + '">';
  return '<div class="cp-head">' + head + '</div>' +
    '<div class="cp-card">' +
      '<a href="' + esc(p.url) + '"><img src="' + esc(img) + '" alt="" loading="lazy"></a>' +
      '<div><a class="cp-name" href="' + esc(p.url) + '">' + esc(String(p.title).replace('A Leading Role x ', '').replace('A Leading Role ', '')) + '</a>' +
        '<div class="cp-price">' + money(variants[0].price) + '</div>' + sizeSel + '</div>' +
      '<button type="button" class="cp-add" data-pair-cart-add>Add</button>' +
    '</div>';
}
function bannerHtml(text){ return '<div class="cp-head">&#10022; ' + text + '</div>'; }
function decorateDrawer(){
  var root = document.getElementById('mbag-root'); if(!root) return;
  var total = root.querySelector('.cart-total');
  if(!total || root.querySelector('#mbag-pair')) return;   /* empty bag, or already decorated */
  /* shorter, more readable line names in the drawer: drop the brand prefix the page already carries */
  root.querySelectorAll('.cart-line .n').forEach(function(n){
    n.textContent = n.textContent.replace(/^A Leading Role x /, '').replace(/^A Leading Role /, '');
  });
  var slot = document.createElement('div');
  slot.className = 'cart-pair'; slot.id = 'mbag-pair'; slot.hidden = true;
  total.parentNode.insertBefore(slot, total);
  var my = ++seq;
  fetch('/cart.js').then(function(r){ return r.json(); }).then(function(cart){
    if(my !== seq || !cart || !cart.items.length) return;
    /* Shopify applies automatic discounts inside cart.js itself, so total_discount is the real saving */
    if(cart.total_discount > 0 && !root.querySelector('.cart-savings')){
      var row = document.createElement('div');
      row.className = 'cart-total cart-savings';
      row.innerHTML = '<span class="t">Bundle savings</span><span class="v">&minus;' + money(cart.total_discount) + '</span>';
      total.parentNode.insertBefore(row, total);
    }
    var inCart = {};
    cart.items.forEach(function(it){ inCart[it.handle] = true; });
    return Promise.all(cart.items.map(function(it){ return getProduct(it.handle); })).then(function(products){
      if(my !== seq) return;
      var famCount = {}, tags = [], hasAccessory = false;
      products.forEach(function(p, i){
        var t = tagsOf(p); tags.push(t);
        if(t.family){ famCount[t.family] = (famCount[t.family] || 0) + cart.items[i].quantity; }
        if(t.family === 'accessory') hasAccessory = true;
      });
      var show = function(html, applied){
        var el = document.getElementById('mbag-pair'); if(my !== seq || !el) return;
        if(!html){ el.hidden = true; el.innerHTML = ''; return; }
        el.classList.toggle('applied', !!applied); el.innerHTML = html; el.hidden = false;
      };
      var i, t;
      /* 1. a dress-up family with a single piece in the bag */
      for(i = 0; i < tags.length; i++){
        t = tags[i];
        var open1 = DRESS[t.family] && famCount[t.family] < 2 ? t.partners.filter(function(h){ return !inCart[h]; })[0] : null;
        if(open1){
          return getProduct(open1).then(function(p){
            show(p && p.available ? nudgeHtml('Complete the pair &mdash; <strong>save 10% on both</strong>', p) : '');
          });
        }
      }
      /* 2. Signature Cooking tiers */
      if(famCount.cooking){
        var c = famCount.cooking;
        if(c >= 4){ return show(bannerHtml('Cooking set complete &mdash; <strong>20% off applied</strong>'), true); }
        var next = c === 1 ? '10%' : (c === 2 ? '15%' : '20%');
        for(i = 0; i < tags.length; i++){
          t = tags[i];
          var open2 = t.family === 'cooking' ? t.partners.filter(function(h){ return !inCart[h]; })[0] : null;
          if(open2){
            return getProduct(open2).then(function(p){
              if(p && p.available){ show(nudgeHtml('Add one more Cooking piece &mdash; <strong>save ' + next + '</strong>', p)); }
              else if(c >= 2){ show(bannerHtml('Cooking saving unlocked &mdash; <strong>' + (c === 2 ? '10%' : '15%') + ' off applied</strong>'), true); }
              else { show(''); }
            });
          }
        }
        if(c >= 2){ return show(bannerHtml('Cooking saving unlocked &mdash; <strong>' + (c === 2 ? '10%' : '15%') + ' off applied</strong>'), true); }
      }
      /* 3. an add-on accessory for a dress up already in the bag. Shopify will not stack the
         20% add-on on top of an already-unlocked buy-2 pair (the dress ups are "used" by that
         discount), so only suggest it while the bag holds a single piece from a family. */
      var unlocked = Object.keys(famCount).some(function(f){ return DRESS[f] && famCount[f] >= 2; });
      if(!hasAccessory && !unlocked){
        for(i = 0; i < tags.length; i++){
          t = tags[i];
          if(DRESS[t.family] && t.addon && !inCart[t.addon]){
            return getProduct(t.addon).then(function(p){
              show(p && p.available ? nudgeHtml('Add-on &mdash; <strong>20% off with your dress up</strong>', p) : '');
            });
          }
        }
      }
      /* nothing left to suggest — confirm the saving when one is already in play */
      show(unlocked ? bannerHtml('Pair saving unlocked &mdash; <strong>10% off applied</strong>') : '', unlocked);
    });
  }).catch(function(){ /* nice-to-have — never break the drawer */ });
}
/* alr.js re-renders #mbag-root's innerHTML on every cart change; decorate after each render */
function watchDrawer(){
  var root = document.getElementById('mbag-root'); if(!root) return;
  var pending = null;
  new MutationObserver(function(){
    if(root.querySelector('#mbag-pair')) return;   /* our own insertions also fire the observer */
    clearTimeout(pending); pending = setTimeout(decorateDrawer, 30);
  }).observe(root, {childList:true});
  decorateDrawer();
}
/* ---------- wiring ---------- */
document.addEventListener('click', function(e){
  var pab = e.target.closest('[data-pair-add]');
  if(pab){ e.preventDefault(); addBoth(pab); return; }
  var pca = e.target.closest('[data-pair-cart-add]');
  if(pca){
    e.preventDefault();
    var sel = pca.parentElement.querySelector('.cp-size');
    var vid = sel ? parseInt(sel.value, 10) : null;
    if(vid){ pca.disabled = true; pca.textContent = '…'; addViaTheme(vid); }
    return;
  }
  if(e.target.closest('.pd-opt button')){ setTimeout(syncSizes, 0); }
});
if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', function(){ syncSizes(); watchDrawer(); }); }
else { syncSizes(); watchDrawer(); }
})();
